import store from '../store'

const Analytics = {
  methods: {
    track (e, props) {
      if (process.env.NODE_ENV == 'development') {
        return
      }
      let channel = store.state.channel
      let defaultObject = {}
      if (channel) {
        let pageCount = 0
        if (channel.pages && channel.pages.length) pageCount = channel.pages.length

        defaultObject = {
          channel: channel.name,
          owner: channel.owner,
          page_count: pageCount,
          tiers: channel.tiers,
          integrated_stripe: channel.stripeAccountId ? true : false
        }
      } else {
        defaultObject = {}
      }
      let trackObject = {
        ...defaultObject
      }
      if (props) {
        trackObject = {
          ...defaultObject,
          ...props
        }
      }
      window.analytics.track(e, trackObject)
    },
    trackAndIdentify (e, props) {
      if (process.env.NODE_ENV == 'development') {
        return
      }
      if (store.state && store.state.user) {
        window.analytics.identify(store.state.user.uid)        
      }
      return this.track(e, props)
    }
  }
}

export default Analytics
